/**
 * @flow
 * @relayHash 24da3f073c94af26e892d115efb8ed36
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type privateRouteQueryVariables = {|
  packageId?: ?number
|};
export type privateRouteQueryResponse = {|
  +packageTracker: ?{|
    +packageInfo: ?{|
      +trackingKey: ?string,
      +companyHash: ?string,
    |}
  |}
|};
export type privateRouteQuery = {|
  variables: privateRouteQueryVariables,
  response: privateRouteQueryResponse,
|};
*/

/*
query privateRouteQuery(
  $packageId: Int
) {
  packageTracker(packageId: $packageId) {
    packageInfo {
      trackingKey
      companyHash
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'packageId',
        type: 'Int',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTracker',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'packageId',
            variableName: 'packageId'
          }
        ],
        concreteType: 'TrackerResultNode',
        plural: false,
        selections: [
          {
            kind: 'LinkedField',
            alias: null,
            name: 'packageInfo',
            storageKey: null,
            args: null,
            concreteType: 'TrackerPackageInfoNode',
            plural: false,
            selections: [
              {
                kind: 'ScalarField',
                alias: null,
                name: 'trackingKey',
                args: null,
                storageKey: null
              },
              {
                kind: 'ScalarField',
                alias: null,
                name: 'companyHash',
                args: null,
                storageKey: null
              }
            ]
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'privateRouteQuery',
      type: 'Query',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'privateRouteQuery',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'query',
      name: 'privateRouteQuery',
      id: null,
      text:
        'query privateRouteQuery(\n  $packageId: Int\n) {\n  packageTracker(packageId: $packageId) {\n    packageInfo {\n      trackingKey\n      companyHash\n    }\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'ace7984ca6f869e3541df21aabe0f289';
module.exports = node;
